import React from 'react'
import { connect } from "react-redux"
import { navigateTo } from 'gatsby-link'
import styled, { css } from 'styled-components'
import { VelocityComponent } from 'velocity-react'
import VisibilitySensor from 'react-visibility-sensor'
import Link from 'gatsby-link'

import { Block } from '../'

import { media } from '../../styles/utils'
import { container, bgIcon, padding, hoverState } from '../../styles/global'
import { ribbon } from '../../styles/colors'
import { resolveBlock } from './utils';
import themes from '../../styles/themes';
import { fetchSettings, getSettings, updateSettings } from '../../store/settings'

class Section extends React.Component {

	state = {
	
	}

	handleVisiblity = (isVisible, theme) => {		
		const { updateSettings } = this.props;

		// if (isVisible) {
		// 	updateSettings({
		// 		theme: theme
		// 	})
		// }
	}

	renderBlocks = (blocks) => {
		const { lastSection } = this.props;

		return blocks.map((block, i) => {                
			return (
				<Block
					layout={block.acf_fc_layout}
					lastSection={lastSection}
					lastBlock={i == blocks.length - 1}
					key={i}
					{...block}
				/>
			)
		})
	}
	
	render() {		
		const { blocks, section } = this.props;
		const theme = themes[section.colour_theme];

		return (
			<VisibilitySensor
				onChange={(isVisible) => this.handleVisiblity(isVisible, theme)}
				scrollDelay={1}
				delayedCall={true}
				partialVisibility={{
					top: 100
				}}
				minTopValue={0}
			>
				{/* No data-colour here any more: the site-wide gradient is
				    driven by ScrollBackground's own evenly spaced stops, so
				    every page shares the homepage's progression. Per-section
				    backgrounds were what made project pages read as blocks. */}
				<Wrapper
					textColour={theme.text}
				>
					{this.renderBlocks(blocks)}
				</Wrapper>
			</VisibilitySensor>
		)
	}
}

const Wrapper = styled.div`
	width: 100%;

	${props => {
		if (props.textColour) return css`
			* {
				color: ${props.textColour} !important;
			}
		`
	}}
`

const mapDispatchToProps = dispatch => ({
    fetchSettings() {
        dispatch(fetchSettings())
    },
    updateSettings(setting) {
        dispatch(updateSettings(setting))
    },
})

const mapStateToProps = (state, props) => ({
    settings: state.settings.settings
})

export default connect(mapStateToProps, mapDispatchToProps)(Section);


// WEBPACK FOOTER //
// ./src/components/Section/Section.js